module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-form', {
    ref: "formEditarPublicidad",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "nombre_archivo",
      "label": "Nombre"
    }
  }, [_c('i-input', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.nombre_archivo),
      callback: function($$v) {
        _vm.form.nombre_archivo = $$v
      },
      expression: "form.nombre_archivo"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "descripcion",
      "label": "Descripción"
    }
  }, [_c('i-input', {
    attrs: {
      "size": "large",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.form.descripcion),
      callback: function($$v) {
        _vm.form.descripcion = $$v
      },
      expression: "form.descripcion"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "texto_audio",
      "label": "Texto audio"
    }
  }, [_c('i-input', {
    attrs: {
      "size": "large",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.form.texto_audio),
      callback: function($$v) {
        _vm.form.texto_audio = $$v
      },
      expression: "form.texto_audio"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "fecha_inicio",
      "label": "Período de vigencia"
    }
  }, [_c('Row', {
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "type": "flex",
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placement": "top-end",
      "format": "dd-MMM",
      "placeholder": "Inicio de la vigencia"
    },
    model: {
      value: (_vm.form.fecha_inicio),
      callback: function($$v) {
        _vm.form.fecha_inicio = $$v
      },
      expression: "form.fecha_inicio"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 12
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placement": "top-end",
      "format": "dd-MMM",
      "placeholder": "Término de la vigencia"
    },
    model: {
      value: (_vm.form.fecha_fin),
      callback: function($$v) {
        _vm.form.fecha_fin = $$v
      },
      expression: "form.fecha_fin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 10
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Archivo actual",
      "prop": "archivo"
    }
  }, [(_vm.model.tipo_archivo === 'Foto') ? _c('span', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "133px",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.model.archivo,
      "alt": _vm.model.nombre_archivo
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.model.tipo_archivo === 'Video') ? _c('span', [_c('video', {
    staticStyle: {
      "width": "100%",
      "height": "133px"
    },
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.model.archivo
    }
  })])]) : _vm._e()])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "files",
      "label": "Subir nuevo archivo"
    }
  }, [(_vm.form.files.length > 0) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.fileType === 'Foto') ? _c('span', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "133px",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.fileUrl,
      "alt": _vm.fileUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.fileType === 'Video') ? _c('span', [_c('video', {
    staticStyle: {
      "width": "100%",
      "height": "133px"
    },
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.fileUrl
    }
  })])]) : _vm._e(), _vm._v(" "), _c('i-button', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    },
    attrs: {
      "type": "error",
      "size": "small"
    },
    on: {
      "click": _vm.removeUpload
    }
  }, [_c('Icon', {
    attrs: {
      "type": "trash-a"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form.files.length > 0),
      expression: "!form.files.length > 0"
    }]
  }, [_c('Upload', {
    ref: "uploaderEdit",
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "type": "drag",
      "headers": _vm.uploadOpts.headers,
      "name": "file",
      "onSuccess": _vm.uploadOpts.onSuccess,
      "onProgress": _vm.uploadOpts.onProgress,
      "onError": _vm.uploadOpts.onError,
      "onRemove": _vm.uploadOpts.onRemove,
      "showUploadList": false,
      "action": _vm.uploadOpts.url
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#c3282b"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Arrastre aquí el archivo que desea agregar")])], 1)])], 1)])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 10
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('i-button', {
    attrs: {
      "type": "error",
      "size": "large",
      "long": "",
      "loading": _vm.isLoading,
      "icon": "close-round"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('i-button', {
    attrs: {
      "type": "success",
      "size": "large",
      "long": "",
      "loading": _vm.isLoading,
      "icon": "checkmark-round"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf3bd724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/publicidad/PublicidadEditForm.vue
// module id = 666
// module chunks = 1